import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { FondoRischiRevisioneFormComponent } from '../../../form/sez-economica/fondo-rischi-revisione-form.component';
import { SezioneEconomicaResponse } from '../../../models/dto/sezione-economica-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { PetitumRevisione } from '../../../models/petitum-revisione';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { FondoRischiRevisioneFormEditComponent } from 'src/app/common/form/sez-economica/fondo-rischi-revisione-form-edit.component';

@Component({
    templateUrl: '../../../form/sez-economica/fondo-rischi-revisione-form-edit.component.html',
  selector: 'div [fondo-rischi-revisione-form-edit]',
})

export class FondoRischiEditRevisioneComponent extends FondoRischiRevisioneFormEditComponent {
  private petitumRevisione: PetitumRevisione;
  private urlUpdate: string;
  private sezione: SezioneEconomica;
  private fascicolo: FascicoloFull;
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @Output() onAnnulla: EventEmitter<void> = new EventEmitter<void>();
  @Input() edit: boolean;

  ngOnInit() {
    this.setTitle('Modifica dati - revisione corrente fondo rischi');
    this.isInserimento(false);
  }

  getPetitumRevisione() {
    return this.petitumRevisione;
  }

  getSezione() {
    return this.sezione;
  }

  getRequest(petitumRevisione: PetitumRevisione) {
    let idSezione: string = PropertiesSettings.NEW_SEZIONE;
    if (this.sezione) {
      idSezione = this.sezione.id;
    }
    this.operationService.updateFondoRischiRevisione(this.urlUpdate, petitumRevisione, idSezione, this.fascicolo.id).
      subscribe((response: any) => this.datiResponse(response));
  }

  datiResponse(response: SezioneEconomicaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneEconomica, petitumRevisione: PetitumRevisione, fascicolo: FascicoloFull, urlUpdate: string, urlSezioneControparti: string, idSezioneControparti: string) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.petitumRevisione = petitumRevisione;
    this.urlUpdate = urlUpdate;
    this.createForm();
    this.populateSelect(urlSezioneControparti, idSezioneControparti);
  }

  closeModal() {
    this.onAnnulla.emit();
  }

  getEdit() {
    return this.edit;
  }
}
